export const LEVEL_COLORS = {
  1: { bg: "#c0392b", light: "#fdecea" },
  2: { bg: "#e07a1a", light: "#fef3e8" },
  3: { bg: "#d4a017", light: "#fef9e7" },
  4: { bg: "#27ae60", light: "#eafaf1" },
  5: { bg: "#1e6fa5", light: "#e8f4fd" },
};

export const LEVELS = [1, 2, 3, 4, 5];
